import ssmlGenerator from './ssml-generator';

export default {
	computed: {
		
	},
	data() {
		return {
			totalDefaultVoiceReplaced: null,
		}
	},
	methods: {
		checkRevoicingDynamicData() {
			const hasDynamicData = this.allTracks.some(f => f.__hasDynamicData());
			return new Promise(res => {
				if (!hasDynamicData) {
					res(false);
				} else {
					this.$confirmMessage({
						title: this.$tCaption('Confirm action', '@actions'),
						text: this.$tCaption('Do you want to re-voice insertions with dynamic data?'),
						buttons: [
							{
								text: this.$tCaption('Re-voice'),
								onClick: () => {
									Promise.all(this.allTracks.filter(f => f.__hasDynamicData()).map(f => ssmlGenerator.generateAndSaveSSMLAudio(this, f))).finally(() => res());
								},
								type: 'success',
								stylingMode: 'text'
							},
							{
								text: this.$tCaption('Skip', '@actions'),
								onClick: () => res(false)
							}
						]
					});
				}
			});
		},
		voiceActivated(voice, v) {
			if (v && voice?.isCustom) {
				let msg = `${this.$tCaption('Your requested voice "VOICE_NAME" is now ready for use')}`
					.replace('VOICE_NAME', voice?.displayName);
				this.$notifySuccess(msg);
				this.$eventsBus.$emit('notification-message', { message: msg });
				this.updateVoiceInsertions(voice);
			}
		},
		async checkDefaultReplacedVoices() {
			if (this.isPublishMode) return this.totalDefaultVoiceReplaced;
			await this.loadSpeechVoices(void 0, this.creative?.Language?.Code);
			let processedVoices = {};
			this.totalDefaultVoiceReplaced = this.loadedTracks
				?.filter(f => f.type === 'textToSpeech' && f.insertion?.JsonConfig?.hasDefaultVoiceReplaced)
				.map(f => {
					let language = this.getLanguage(f.insertion.Language);
					let voice = this.findVoice(f.insertion.Voice, language);

					if (__DEBUG__)
						console.debug('checkDefaultReplacedVoices', { voice, language });

					if (voice && !processedVoices[`${voice?.id}_${language}_${f.insertion.VoiceStyle}`]) {
						processedVoices[`${voice?.id}_${language}_${f.insertion.VoiceStyle}`] = true;

						if (!voice.isActive) {
							if (!voice.isResuming) {
								this.activateVoice(voice, void 0, f.insertion.VoiceStyle);
							}
						} else {
							this.updateVoiceInsertions(voice);
						}
					}
				}).length;

			return this.totalDefaultVoiceReplaced;
		},
		updateVoiceInsertions(voice) {
			this.loadSpeechVoices(void 0, this.creative?.Language?.Code)
				.then(() => {
					this.loadedTracks
						.filter(f => f.type === 'textToSpeech' && f.insertion.Voice === voice?.id && f.insertion.JsonConfig.hasDefaultVoiceReplaced)
						.map(async (f) => {
							if (f.__isUpdatingDefaultVoice) return;

							f.__isUpdatingDefaultVoice = true;
							try {
								await ssmlGenerator.generateAndSaveSSMLAudio(this, f, void 0, {
									onAudioGenerated: () => {
										if (this.$refs.tracker?.isPlaying) {
											this.$refs.tracker.stop();
											this.$notifyInfo('Playback stopped because of premium voice has been activated.', '@Creative')
										}
									}
								});
								f.__saveInsertion('updateVoiceInsertions');
								f.insertion.JsonConfig.hasDefaultVoiceReplaced = false;

								if (f.insertion?.__inMemory) {
									f.src = f.__tracker.tracksBase64[f.id] || f.src;
								}
							} finally {
								f.__isUpdatingDefaultVoice = false;
							}
							this.checkDefaultReplacedVoices();
						})
				});
		},
	}
};
